import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddVendorQuotationMutation } from "store/services/vendorQuotationApi";
import VendorQuotationForm from "./vendorQuotationComponents/VendorQuotationForm";

const VendorQuotationCreateScreen = () => {
    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Vendor Quotations", path: "/app/crm/vendor-quotation/list" },
        { title: "New Vendor Quotation" },
    ];

    const [addVendorQuotation, { isLoading }] = useAddVendorQuotationMutation();

    const handleCreate = async (data) => {
        try {
            const { _id } = await addVendorQuotation(data).unwrap();
            toast.success("Vendor Quotation successfully created!");
            navigate(`/app/crm/vendor-quotation/${_id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't create Vendor Quotation!"
            );
        }
    };

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
            <BreadcrumbLayout.Paper>
                <VendorQuotationForm isBusy={isLoading} onSubmit={handleCreate} />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VendorQuotationCreateScreen;